<template>
  <!-- Поля обёрнуты в <label> — связь с контролом есть и без id -->
  <!-- eslint-disable vuejs-accessibility/label-has-for -->
  <div v-if="day" class="w-hours-day">
    <div class="w-hours-heading">
      <h3>{{ title }}</h3>
      <label>
        <input type="checkbox" :checked="!day.open.length" @change="onDayOffChange" />
        Выходной
      </label>
    </div>
    <div class="w-hours-columns">
      <div v-for="column in COLUMNS" :key="column.type" class="w-hours-column">
        <span class="w-small">{{ column.title }}</span>
        <div class="w-hours-list">
          <div
            v-for="(interval, index) in day[column.type]"
            :key="index"
            class="w-hours-interval"
          >
            <input
              v-model.lazy="interval.start"
              type="time"
              step="60"
              :aria-label="`${title} · ${column.name} · начало ${index + 1}`"
              @change="store.markBranchEdited()"
            />
            <span aria-hidden="true">–</span>
            <input
              v-model.lazy="interval.end"
              type="time"
              step="60"
              :aria-label="`${title} · ${column.name} · окончание ${index + 1}`"
              @change="store.markBranchEdited()"
            />
            <button
              class="w-button w-ghost w-icon"
              type="button"
              :aria-label="`${title} · убрать интервал ${column.genitive} ${index + 1}`"
              @click="store.removeInterval(props.kind, props.index, column.type, index)"
            >
              <q-icon name="close" />
            </button>
          </div>
          <span v-if="!day[column.type].length" class="w-small">{{ column.empty }}</span>
        </div>
        <button
          class="w-button w-ghost"
          type="button"
          :disabled="column.type === 'intake' && !day.open.length"
          @click="store.addInterval(props.kind, props.index, column.type)"
        >
          <q-icon name="add" />
          Интервал
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useScheduleStore } from '@/store/calendar/scheduleModule';
import type { DraftDayKind } from '@/store/calendar/scheduleModule';
import type { HoursType } from '@/store/calendar/types';

type BranchDayEditorProps = {
  kind: DraftDayKind;
  index: number;
  title: string;
};

type HoursColumn = {
  type: HoursType;
  title: string;
  name: string;
  genitive: string;
  empty: string;
};

const COLUMNS: HoursColumn[] = [
  {
    type: 'open', title: 'Работа филиала', name: 'работа', genitive: 'работы', empty: 'Закрыто',
  },
  {
    type: 'intake', title: 'Приём пациентов', name: 'приём', genitive: 'приёма', empty: 'Приёма нет',
  },
];

const props = defineProps<BranchDayEditorProps>();

const store = useScheduleStore();

// День берётся из черновика по индексу — редактор меняет стор, а не свои props
const day = computed(() => store.draftDay(props.kind, props.index));

const onDayOffChange = (event: Event) => {
  store.setDayOff(props.kind, props.index, (event.target as HTMLInputElement).checked);
};
</script>
